import { Grid, styled } from '@mui/material';
import { TextField } from '@totalsoft/rocket-ui';
import { DenseTableCell } from 'components/common/CommonStyles';

export const SearchField = styled(TextField)(() => ({
  width: '50%',
  marginBottom: '25px'
}));

export const SearchGrid = styled(Grid)(() => ({
  textAlign: 'right',
}));

export const TableGrid = styled(Grid)(() => ({
height:'400px'
}));

export const AddServicesHeaderTableCell= styled(DenseTableCell)(()=>({
  borderBottom: '2px solid rgb(0 0 0 / 45%)'
}));
